import styles from '../../../CSS/main.css'
import Row from '../List/Row'
import { Col } from '../List/Col'
import DatePicker from 'react-datepicker'
import React from 'react'
import { DateFilterType } from './types'
import { ParamsUpdater } from '../List/hooks'

type DateRangeFilterProps<T> = {
  readonly filter: DateFilterType<T>
  readonly start: Date | null
  readonly end: Date | null
  readonly updateParams: ParamsUpdater<T>
}
export const DateRangeFilter = <T,>({
                                      filter,
                                      start,
                                      end,
                                      updateParams,
                                    }: DateRangeFilterProps<T>): JSX.Element => {
  return (
    <>
      <div className={styles.Table}>
        <Row>
          <Col>Start:</Col>{' '}
          <Col>
            <DatePicker
              selectsStart
              selected={start}
              startDate={start}
              endDate={end}
              onChange={(d: Date) => updateParams(filter.startFieldName, d)}
            />
          </Col>
        </Row>
        <Row>
          <Col>End:</Col>{' '}
          <Col>
            <DatePicker
              selectsEnd
              selected={end}
              startDate={start}
              endDate={end}
              onChange={(d) => updateParams(filter.endFieldName, d)}
            />
          </Col>
        </Row>
      </div>
    </>
  )
}
